<template>
  <div class="school_content">
    <!-- learningStyle学习方式（1=不限、2=闯关学习） -->
    <!-- <div class="flex Flexalign school_top">
      <div>学堂 ></div>
      <el-select v-model="chapterValue" placeholder="" filterable no-match-text="未搜到课程" size="large"
        style="width: 188px; height: 36px; margin: 0 8px" @change="changeChapter">
        <el-option v-for="item in chapterOptions" :key="item.value" :label="item.label" :value="item.value" />
      </el-select>
    </div> -->
    <div class="five_step_box mb-20" v-if="true">
      <fiveStep :step="0" :courseSettingInfo="courseSettingInfo"></fiveStep>
    </div>
    <div class="video-player">
      <div class="flex FlexBetween Flexalign wordTextarea_top px-20 video_top" v-if="playType != 6 && playType != 7">
        <div class="exercise-title">· 课程学习</div>
        <div class="flex Flexalign">
          <div class="btn_view btn_previous btn_next btn_next_new my-15 cursor_pointer" @click="previoustep">
            上一步
          </div>
          <div class="btn_view btn_next ml-20 btn_next_new my-15 cursor_pointer" @click="nextStep()">
            下一步
          </div>
        </div>
      </div>
      <videomuiPlayer :src="playerOptions.src" :key="playerOptions.src" :courseDetail="courseDetail"
        :courseSettingInfo="courseSettingInfo" v-if="playType == 1" @changePlayType="changePlayType"></videomuiPlayer>
      <div class="live_play_box mt-20 flex Flexalign flexcolumn Flexjustify"
        :style="{ backgroundImage: `url(${selectLearningInfo.chapterResource.liveCoverImg})` }" v-else-if="playType == 2">
        <div>直播课程暂未开始</div>
        <div class="live_time mt-15">
          {{
            $Tools.formatTimeInterval(
              selectLearningInfo.chapterResource.liveStartTime,
              selectLearningInfo.chapterResource.liveEndTime
            )
          }}
        </div>
        <div class="qrcode_box mar_top_20 flex flexcolumn Flexalign Flexjustify mt-20">
          <qrcode-vue :value="qrCodeValue" :size="114"></qrcode-vue>
        </div>
        <div class="live_text mt-15">扫码咨询课程详情</div>
      </div>
      <div class="live_play_box mt-20 flex Flexalign flexcolumn Flexjustify"
        :style="{ backgroundImage: `url(${selectLearningInfo.chapterResource.liveCoverImg})` }" v-else-if="playType == 3">
        <div>直播课程已开始</div>
        <div class="btn_view mt-15 cursor_pointer" @click="videoLiveBroadcast">
          立即观看
        </div>
      </div>
      <div class="live_play_box flex Flexalign flexcolumn Flexjustify" v-else-if="playType == 4">
        <div>学习视频已观看完成，是否前往习题巩固</div>
        <div>解锁下一阶段的学习任务</div>
        <el-image class="line_empty mt-20" :src="iconPath('line_empty.png')"></el-image>
        <div class="btn_view btn_next mt-15 cursor_pointer" @click="nextStep()">
          下一步
        </div>
        <div class="play_again mt-10 cursor_pointer" @click="changePlayType(1)">
          再次观看
        </div>
      </div>
      <div class="live_play_box mt-20 flex Flexalign flexcolumn Flexjustify" v-else-if="playType == 5"
        :style="{ backgroundImage: `url(${selectLearningInfo.chapterResource.liveCoverImg})` }">
        <div>直播课程暂已结束，请等待老师上传录播课程</div>
        <div class="btn_view btn_next mt-15 cursor_pointer" @click="nextStep()">
          下一步
        </div>
      </div>
      <div class="live_play_box mt-20 flex Flexalign flexcolumn Flexjustify live_wordTextarea live_courseware"
        v-else-if="playType == 6" id="wordTextarea">
        <div class="flex FlexBetween Flexalign wordTextarea_top px-20">
          <div>· 图文资料</div>
          <div class="flex lexalign">
            <div class="btn_view btn_previous btn_next btn_next_new my-15 cursor_pointer" @click="previoustep">
              上一步
            </div>
            <div class="btn_view btn_next btn_next_new ml-20 my-15 cursor_pointer" @click="nextStep('live')">
              下一步
            </div>
          </div>
        </div>
        <div class="word_text_area" v-html="$Tools.handlerImg(selectLearningInfo.chapterResource.wordTextarea)"></div>
        <el-image class="full_screen_icon mt-20 cursor_pointer" :src="iconPath('full_screen_icon.png')"
          @click="fullScreen('wordTextarea')"></el-image>
      </div>
      <div class="live_play_box mt-20 flex Flexalign flexcolumn Flexjustify live_wordTextarea live_courseware"
        v-else-if="playType == 7" id="coursewareJson">
        <!-- <div class="doc-tabs">
          <div v-for="(doc, index) in documentList" :key="index" @click="switchDoc(doc)"
            :class="{ active: currentIndex === index }">
            {{ doc.name }}
          </div>
        </div> -->
        <!-- <iframe class="word_text_area" frameborder="0"
          :src="`https://view.officeapps.live.com/op/view.aspx?src=${documentUrl}`"></iframe> -->
        <div class="flex Flexalign mt-20 mb-20 FlexBetween px-20" style="width: 100%; box-sizing: border-box">
          <div class="flex Flexalign">
            <div>课件选择：</div>
            <el-select v-model="documentUrl" placeholder="Select" style="width: 240px">
              <el-option v-for="item in documentList" :key="item.url" :label="item.name" :value="item.url" />
            </el-select>
          </div>
          <div class="flex lexalign">
            <div class="btn_view btn_previous btn_next btn_next_new my-15 cursor_pointer" @click="previoustep">
              上一步
            </div>
            <div class="btn_view btn_next btn_next_new ml-20 my-15 cursor_pointer" @click="nextStep('live')">
              下一步
            </div>
          </div>
        </div>
        <div class="preview-wrapper">
          <iframe v-if="isDirectPreview" :src="documentUrl" frameborder="0" width="100%" height="100%"></iframe>
          <iframe v-else-if="isOfficeDoc" :src="`https://view.officeapps.live.com/op/embed.aspx?src=${documentUrl}`"
            frameborder="0" width="100%" height="100%"></iframe>
          <div v-else-if="!isOfficeDoc && !isDirectPreview" class="unsupported flex flexcolumn Flexalign">
            暂不支持此格式预览，请下载后查看
            <div class="btn_download mt-20 cursor_pointer" @click="$Jump.open(documentUrl, {}, false)">
              下载
            </div>
          </div>
        </div>
        <el-image class="full_screen_icon mt-20 cursor_pointer" :src="iconPath('full_screen_icon.png')"
          @click="fullScreen('coursewareJson')"></el-image>
      </div>
      <div class="video_bottom flex Flexalign FlexBetween">
        <div class="video_bottom_left flex Flexalign">
          <div class="flex Flexalign cursor_pointer" @click="collectCourse(true)" v-if="!collected">
            <el-image class="follow_icon" :src="iconPath('follow_icon.png')"></el-image>
            <div class="follow_text">收藏</div>
          </div>
          <div class="flex Flexalign cursor_pointer" @click="collectCourse(false)" v-if="collected">
            <el-image class="follow_icon" :src="imgPath('collected_icon.png')"></el-image>
            <div class="follow_text">已收藏</div>
          </div>
          <!-- <el-image class="follow_icon mar_left_30" :src="iconPath('discuss_icon.png')"></el-image>
          <div class="follow_text cursor_pointer" @click="discuss">讨论</div> -->
        </div>
        <div class="video_bottom_left flex Flexalign">
          <div class="flex Flexalign cursor_pointer" @click="takeNotes">
            <el-image class="follow_icon" :src="iconPath('take_notes_icon.png')"></el-image>
            <div class="follow_text">记笔记</div>
          </div>
          <!-- <div class="more_icon mar_left_30 cursor_pointer">
            <el-icon color="rgba(102, 102, 102, 1)" :size="16">
              <More />
            </el-icon>
          </div> -->
        </div>
      </div>
    </div>

    <div class="lecturer_info mar_top_20">
      <div class="menu_list flex">
        <div class="menu_one flex flexcolumn Flexalign cursor_pointer" v-for="(item, index) in menuList" :key="index"
          @click="chaneMenu(item)">
          <div :class="[item.value == selectMenu ? 'active_text' : '']">
            {{ item.label }}
          </div>
          <div :class="[item.value == selectMenu ? 'line_active' : '']"></div>
        </div>
      </div>
      <div>
        <!-- 讨论 -->
        <discuss v-if="selectMenu == 0" :courseId="courseDetail.courseId"></discuss>
        <!-- 评论 -->
        <evaluate v-if="selectMenu == 1" :courseId="courseDetail.courseId" :courseDetail="courseDetail"></evaluate>
        <!-- 课件资料 -->
        <courseware v-if="selectMenu == 2" :courseId="courseDetail.courseId"></courseware>
        <!-- 随堂练习 -->
        <classroomPractice v-if="selectMenu == 3" :courseId="courseDetail.courseId"></classroomPractice>
      </div>
    </div>
    <takeNotes ref="takeNotes"></takeNotes>
  </div>
</template>

<script>
import screenfull from "screenfull";
import discuss from "@/components/course/discuss.vue";
import evaluate from "@/components/course/evaluate.vue";
import courseware from "@/views/course/components/courseware.vue";
import takeNotes from "@/components/popup/takeNotes.vue";
import classroomPractice from "./classroomPractice.vue";
import QrcodeVue from "qrcode.vue";
import fiveStep from "./fiveStep.vue";
import { debounce } from "@/assets/utils/dbucTrtl";
import { mapState } from "vuex";
export default {
  name: "GjkcH5School",
  components: {
    discuss,
    evaluate,
    courseware,
    takeNotes,
    classroomPractice,
    QrcodeVue,
    fiveStep,
  },
  props: {
    courseDetail: {},
    videoUrl: {},
    courseSettingInfo: {},
  },
  computed: {
    ...mapState({
      selectLearningInfo: (state) => state.learning.selectLearningInfo,
      courseChapterList: (state) => state.learning.courseChapterList,
    }),

    // 浏览器原生支持的格式（PDF/图片等）
    isDirectPreview() {
      const ext = this.getFileExtension(this.documentUrl);
      return ["pdf", "jpg", "png", "jpeg"].includes(ext);
    },

    // Office文档格式
    isOfficeDoc() {
      const ext = this.getFileExtension(this.documentUrl);
      return ["doc", "docx", "xls", "xlsx", "ppt", "pptx"].includes(ext);
    },
  },
  watch: {
    videoUrl: {
      handler(val) {
        if (val) {
          this.playerOptions.src = val;
        }
      },
    },
    selectLearningInfo: {
      handler(val) {
        this.getVideoUrl(val);
      },
      deep: true,
    },
    courseChapterList: {
      deep: true,
      handler(val) {
        if (val.length) {
          val.forEach((item) => {
            // 此处也需要判断是否是闯关学习，闯关学习情况下要判断当前学习的课程进度，只能选择之前的课程，不能选择后面未学习的章节(不放在数组中)
            this.chapterOptions.push({
              label: item.chapterName,
              value: item.chapterId,
            });
          });
          // 初始先默认第一个章节(后期优化为上次观看至)
          this.chapterValue = val[0].chapterId;
          this.originChapterValue = val[0].chapterId;
          // this.$store.commit("learning/setSelectLearningInfo", val[0]);
        }
      },
    },
    courseDetail: {
      handler() {
        this.getCollectInfo();
        // 闯关学习去判断当前学习到的章节
        // if(this.courseDetail.learningStyle == 2){

        // }
      },
      deep: true,
    },
  },
  data() {
    return {
      chapterValue: "",
      originChapterValue: "",
      chapterOptions: [],
      playerOptions: {
        src: ".", // 替换为你的实际视频链接https://muiplayer.js.org/media/media.mp4，设置为空会因为接口请求需要时间弹出视频地址为空的提示
        autoplay: false,
        controls: true,
        // 其他配置选项
      },
      menuList: [
        // { label: "随堂练习", value: 3 },
        { label: "问答", value: 0 },
        { label: "评价", value: 1 },
        // { label: "课件资料", value: 2 },
      ],
      selectMenu: 0,
      collected: false, // 是否收藏
      collectParams: {
        collectType: 3,
        associatedIds: "",
      },
      playType: 1, // 课程学习方式，1：视频，2：直播未开始，3：直播一开始，4：已学完，5：已学完，下一步，6：图文学习
      qrCodeValue: "",
      timeInterval: null,
      isToastCooling: false,
      documentList: [], // 图文课件列表
      documentUrl: "", // 选中的图文课件
      isFullscreen: false, // 是否全屏
    };
  },

  mounted() {
    this.getCollectInfo();
    this.getVideoUrl(this.selectLearningInfo);
    // 判断是否直播课程，直播课程需要定时循环直播是否开始(一分钟判断一次)
    if (!this.$Tools.empty(this.selectLearningInfo)) {
      if (!this.$Tools.empty(this.selectLearningInfo?.chapterResource)) {
        if (this.selectLearningInfo.chapterResource.teachingMethod == 2) {
          const nowTime = new Date().getTime();
          const startTime = new Date(
            this.selectLearningInfo.chapterResource.liveStartTime
          ).getTime();
          if (nowTime < startTime) {
            this.timeInterval = setInterval(() => {
              this.getVideoUrl(this.selectLearningInfo);
            }, 60000);
          }
        }
      }
    }
  },
  onMounted() {
    if (this.timeInterval) {
      clearInterval(this.timeInterval);
      this.timeInterval = null;
    }
  },

  methods: {
    // 全屏
    fullScreen(type) {
      let elementDom = "";
      if (type == "wordTextarea") {
        elementDom = document.getElementById("wordTextarea");
      } else if (type == "coursewareJson") {
        elementDom = document.getElementById("coursewareJson");
      }
      if (!screenfull.isEnabled) {
        this.$Dialog.toast("当前浏览器不支持全屏", { type: "warning" });
        return;
      }
      screenfull.toggle(elementDom);
      this.isFullscreen = screenfull.isFullscreen;
    },
    videoLiveBroadcast() {
      window.open(this.qrCodeValue);
    },
    getVideoUrl(val) {
      if (!this.$Tools.empty(val)) {
        if (this.$Tools.empty(val?.chapterResource)) {
          this.playerOptions.src = ".";
          this.playType = 1; // 恢复视频框内容
          // this.$Dialog.toast("当前轮次/方案未配置章节学习视频，请联系客服人员", {
          //   type: "warning",
          // });
          return;
        }
        if (val?.chapterResource.teachingMethod == 2) {
          const nowTime = new Date().getTime();
          const startTime = new Date(val.chapterResource.liveStartTime).getTime();
          const endTime = new Date(val.chapterResource.liveEndTime).getTime();
          // 表示直播已结束（存在录播视频则播放视频资源，没有弹框提示等待上传录播资源）
          if (nowTime > endTime) {
            if (val?.chapterResource?.videoPath) {
              this.playerOptions.src = val?.chapterResource?.videoPath;
              this.chapterValue = val?.chapterId;
              this.playType = 4;
            } else {
              this.showLockedToast();
              this.playType = 5;
            }
          }
          // 直播未开始
          if (nowTime < startTime) {
            this.playType = 2;
            this.qrCodeValue = val.chapterResource.liveUrl;
          }
          // 直播已开始未结束
          if (nowTime > startTime && nowTime < endTime) {
            this.playType = 3;
            this.qrCodeValue = val.chapterResource.liveUrl;
          }
        } else if (val?.chapterResource.teachingMethod == 1) {
          // 选择视频（此处需加上试看视频/视频）
          this.playerOptions.src = val?.chapterResource?.videoPath;
          this.chapterValue = val?.chapterId;
          this.playType = 1;
        } else if (val?.chapterResource.teachingMethod == 3) {
          // 富文本方式
          this.playType = 6;
        } else if (val?.chapterResource.teachingMethod == 4) {
          // 图文方式
          this.playType = 7;
          this.documentList = JSON.parse(val?.chapterResource.coursewareJson);
          this.documentUrl = this.documentList[0]?.url;
        }
        //   if (this.originChapterValue != this.chapterValue) {
        //     this.changeChapter();
        //   }
        // } else {
        //   this.$Dialog.toast("当前轮次/方案未配置章节，请联系客服人员", {
        //     type: "error",
        //   });
        //   this.playerOptions = {
        //     src: ".",
        //     autoplay: false,
        //     controls: true,
        //   };
      }
    },
    // 切换文档
    switchDoc(doc) {
      this.documentUrl = doc.url;
    },
    // 获取文件扩展名
    getFileExtension(url) {
      return url.split(".").pop().toLowerCase();
    },
    async showLockedToast() {
      if (this.isToastCooling) return;

      this.isToastCooling = true;
      // this.$Dialog.toast("请等待老师上传录播资源后再观看", { type: 'warning' });
      this.$Dialog.confirm({
        message: "是否已观看直播，直接进入下一步学习",
        title: "提示", // 可选，不传则使用默认值'确认'
        onConfirm: () => {
          this.nextStep("live");
        }, // 确认后的操作，如调用删除API等
        onCancel: () => { },
      });

      await new Promise((resolve) =>
        setTimeout(() => {
          this.isToastCooling = false;
          resolve();
        }, 2000)
      );
    },

    // 用于直播授课主动触发完成输入阶段
    confirmPassInputStatus() {
      if (!this.selectLearningInfo.chapterResource?.schemeChapterPhaseId) return;
      this.$Api.learning
        .confirmPassInputStatus({
          schemeChapterPhaseId: this.selectLearningInfo.chapterResource
            ?.schemeChapterPhaseId,
        })
        .then(() => {
          // this.$store.commit("learning/setStudySteps");
          this.confirmNext();
        })
        .catch(() => { });
    },
    // 上一步（没有上一章节阶段）
    previoustep() {
      this.$store.commit("learning/setStudyPreviousStep", 1);
    },
    // 下一步进入作业
    nextStep(type) {
      // 新增type不是live时，此时若允许跳过录播课则一样允许直接下一步
      if (!type) {
        console.log(this.courseSettingInfo);
        if (this.courseSettingInfo.learningAllowSkipInput == 1) {
          this.confirmPassInputStatus();
          return;
        }
      }
      // 新增type类型,type为live主动触发，否则直接跳下一步
      if (type != "live") {
        // this.$store.commit("learning/setStudySteps");
        this.confirmNext();
      } else {
        this.confirmPassInputStatus();
      }
    },
    confirmNext: debounce(
      function () {
        this.$store.commit("learning/setStudySteps");
      },
      1000,
      false
    ),
    changePlayType(playType) {
      this.playType = playType;
    },
    // 选择章节
    changeChapter() {
      if (this.courseDetail.learningStyle == 2) {
        // 判断当前章节是否可学习（前一章节是否有提交次数）
        // let lastChapter = this.chapterOptions.findIndex(
        //   (item) => item.value == this.chapterValue
        // );
        // 查询前一章节是否有测验提交（有再判断parentId是否相同，不相同说明不是同一目录，此时需要再查询目录测验是否已完成（一层一层查，建议直接查最外面那一层），已完成方可进行学习）
        let parentId1 = this.courseChapterList.filter(
          (item) => item.chapterId == this.originChapterValue
        )[0]?.parentId;
        let parentId2 = this.courseChapterList.filter(
          (item) => item.chapterId == this.chapterValue
        )[0]?.parentId;
        let chapterId = "";
        if (parentId1 == parentId2) {
          chapterId = this.originChapterValue;
          // this.originChapterValue = this.chapterValue;
        } else {
          chapterId = this.getTopParent(parentId1);
        }
        this.$Api.exam
          .getLastChapterBySubmitCount({ chapterIds: [chapterId] })
          .then((res) => {
            if (res.data.data?.submitCountList) {
              if (res.data.data?.submitCountList[0]?.submitCount == 0) {
                this.$Dialog.toast("请先完成前一章节的测试后再学习", {
                  type: "warning",
                });
                this.chapterValue = this.originChapterValue;
                let selectChapter = this.courseChapterList.filter(
                  (item) => item.chapterId == this.chapterValue
                )[0];
                this.$store.commit("learning/setSelectLearningInfo", selectChapter);
              } else {
                this.originChapterValue = this.chapterValue;
              }
            }
          })
          .catch(() => { });
        return;
      }
      let selectChapter = this.courseChapterList.filter(
        (item) => item.chapterId == this.chapterValue
      )[0];
      this.$store.commit("learning/setSelectLearningInfo", selectChapter);
    },
    getTopParent(chapterId) {
      let current = this.courseChapterList.filter(
        (item) => item.chapterId == chapterId
      )[0];
      if (!current) return chapterId;

      while (current.parentId) {
        const parent = this.courseChapterList.filter(
          (item) => item.chapterId == current.parentId
        )[0];
        if (!parent) break;
        current = parent;
      }

      return current;
    },
    chaneMenu(info) {
      this.selectMenu = info.value;
    },
    // 课程收藏关系
    getCollectInfo() {
      if (this.$Tools.empty(this.courseDetail)) return;
      this.collectParams.associatedIds = this.courseDetail.courseId;
      this.collectParams.collectType = 3;
      this.$Api.course
        .getCollectInfo(this.collectParams)
        .then((res) => {
          const idx = res.data.data.findIndex(
            (item) => item == this.courseDetail.courseId
          );
          if (idx != -1) {
            this.collected = true;
          } else {
            this.collected = false;
          }
        })
        .catch(() => { });
    },
    // 收藏
    collectCourse(flag) {
      this.collectedCourse(flag);
    },
    collectedCourse: debounce(
      function (flag) {
        this.$Api.course
          .collectCourse({ courseId: this.courseDetail.courseId })
          .then(() => {
            if (flag) {
              this.$Dialog.toast("收藏成功");
            } else {
              this.$Dialog.toast("已取消收藏", { type: "warning" });
            }
            this.getCollectInfo();
          })
          .catch(() => { });
      },
      1000,
      false
    ),
    // 讨论
    discuss() { },
    // 记笔记
    takeNotes() {
      if (this.$Tools.empty(this.selectLearningInfo)) {
        this.$Dialog.toast("暂无章节信息，无法记录笔记");
        return;
      }
      this.$refs.takeNotes.myTakeNotesShow = true;
      this.$refs.takeNotes.noteInfo.chapterId = this.selectLearningInfo.chapterId;
    },
  },
};
</script>
<style lang="scss" scoped>
.mar_left_30 {
  margin-left: 30px;
}

.mar_top_20 {
  margin-top: 20px;
}

.school_content {
  width: 762px;

  .school_top {
    width: 100%;
    color: #111111;
    font-weight: 600;
  }

  .video-player {
    max-width: 762px;

    .exercise-title {
      font-size: 18px;
      font-weight: 600;
    }

    .btn_view {
      width: 85px;
      height: 36px;
      background: linear-gradient(97deg, #00d498 0%, #00d5c2 100%);
      border-radius: 18px;
      text-align: center;
      line-height: 36px;
      color: #fff;
    }

    .btn_next {
      width: 69px;
      height: 30px;
      line-height: 30px;
      background: linear-gradient(122deg, #ff8a4c 0%, #fe5e3c 100%);
      border-radius: 21px;
    }

    .btn_next_new {
      background: linear-gradient(97deg, #00d498 0%, #00d5c2 100%);
    }

    .btn_previous {
      background: none;
      border: 1px solid #909090;
      color: #909090;
    }

    // margin: 10px 0;
    .video_top {
      background: #fff;
      border-radius: 10px 10px 0 0;
    }

    .video_bottom {
      width: 762px;
      height: 46px;
      background: #ededed;
      border-radius: 0px 0px 10px 10px;
      padding: 0 20px;
      box-sizing: border-box;

      .video_bottom_left {
        .follow_icon {
          width: 24px;
          height: 24px;
        }

        .follow_text {
          margin-left: 5px;
          font-size: 14px;
          color: #666666;
        }

        .more_icon {
          transform: rotate(90deg);
        }
      }
    }
  }

  .live_play_box {
    width: 762px;
    height: 450px;
    background: #1d2227;
    border-radius: 10px 10px 0px 0px;
    color: #ffffff;
    background-size: 100% 100%;

    .live_time {
      font-size: 14px;
      color: #13d6aa;
    }

    .live_text {
      font-size: 14px;
      color: #999999;
    }

    .qrcode_box {
      width: 130px;
      height: 130px;
      position: relative;
      border: 1px solid #999;
      border-radius: 10px;
      background: #fff;
    }

    .line_empty {
      width: 170px;
      height: 19px;
    }

    .play_again {
      font-size: 12px;
      color: #ff6619;
    }
  }

  .live_wordTextarea {
    background: #ffffff;
    color: #111111;
    position: relative;

    .wordTextarea_top {
      width: 100%;
      box-sizing: border-box;
      border-bottom: 1px solid #dcdada;
    }

    .word_text_area {
      box-sizing: border-box;
      padding: 20px 20px 0;
      height: 100%;
      width: 100%;
      overflow-y: auto;
    }

    .full_screen_icon {
      width: 56px;
      height: 56px;
      position: absolute;
      right: 20px;
      bottom: 20px;
    }

    .doc-tabs {
      width: 200px;
      border-right: 1px solid #eee;
      overflow-y: auto;
    }

    .doc-tabs>div {
      padding: 12px 15px;
      cursor: pointer;
      border-bottom: 1px solid #f5f5f5;
    }

    .doc-tabs>div.active {
      background: #e6f7ff;
      border-left: 3px solid #1890ff;
      font-weight: bold;
    }

    .preview-wrapper {
      width: 100%;
      flex: 1;
      position: relative;

      .btn_download {
        width: 85px;
        height: 36px;
        background: linear-gradient(97deg, #00d498 0%, #00d5c2 100%);
        border-radius: 18px;
        text-align: center;
        line-height: 36px;
        color: #fff;
      }

      #SaveToCloudStorage {
        display: none;
      }
    }

    .unsupported {
      // display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      color: #999;
      font-size: 18px;
    }
  }

  .live_courseware {
    height: 550px;
  }

  .lecturer_info {
    width: 762px;
    background: #ffffff;
    border-radius: 10px;
    padding: 15px 20px;
    box-sizing: border-box;
    margin-bottom: 20px;

    .menu_list {
      border-bottom: 1px solid rgba(20, 20, 20, 0.1);

      .menu_one {
        line-height: 50px;
        margin: 0 10px;
        position: relative;
      }

      .active_text {
        color: #13d6aa;
        font-weight: 600;
      }

      .line_active {
        position: absolute;
        bottom: 0;
        width: 20px;
        height: 2px;
        background: #13d6aa;
      }
    }
  }
}
</style>
